export default __webpack_public_path__ + "slices/main/assets/public/fonts/inter/inter-medium.5b53c519b3184a74a98ca6125f513c9d.woff2";